"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Star = () => /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "0 0 40 40"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M12.0252101 33L20 8 27.9747899 33 7 17.5132743 33 17.5132743z"
}));

var _default = Star;
exports.default = _default;